import { useState } from "react";
import { BsKeyFill, BsEyeFill, BsEyeSlashFill } from "react-icons/bs";
import { HiCheck, HiOutlineLockClosed } from "react-icons/hi2";
import useInput from "../../hooks/userInput";
import { useCookies } from "react-cookie";
import { useDispatch } from "react-redux";

import cf from "../UI/ClassicForm.module.css";
import { alertActions } from "../../store/alert-slice";
import { updatePassword } from "../../api/api";
import Spinner from "../UI/Spinner";

const Password = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [passwordType, setPasswordType] = useState("password");
  const [showPassword2, setShowPassword2] = useState(false);
  const [passwordType2, setPasswordType2] = useState("password");
  const [showPassword3, setShowPassword3] = useState(false);
  const [passwordType3, setPasswordType3] = useState("password");
  const { jwt } = useCookies(["jwt"])[0];
  const [showSpinner, setShowSpinner] = useState(false);
  const dispatch = useDispatch();
  const {
    value: currentPasswordInput,
    enteredValueIsValid: currentPasswordInputIsValid,
    hasError: currentPasswordInputIsInvalid,
    valueInputChangedHandler: currentPasswordInputChangedHandler,
    valueInputBlurHandler: currentPasswordInputBlurHandler,
    reset: currentPasswordInputReset,
  } = useInput((value) => value.trim() !== "");

  const {
    value: passwordInput,
    enteredValueIsValid: passwordInputIsValid,
    hasError: passwordInputIsInvalid,
    valueInputChangedHandler: passwordInputChangedHandler,
    valueInputBlurHandler: passwordInputBlurHandler,
    reset: passwordInputReset,
  } = useInput((value) => value.trim() !== "");

  const {
    value: confirmPasswordInput,
    enteredValueIsValid: confirmPasswordInputIsValid,
    hasError: confirmPasswordInputIsInvalid,
    valueInputChangedHandler: confirmPasswordInputChangedHandler,
    valueInputBlurHandler: confirmPasswordInputBlurHandler,
    reset: confirmPasswordInputReset,
  } = useInput((value) => value.trim() !== "");

  let formIsValid = false;
  if (
    currentPasswordInputIsValid &&
    passwordInputIsValid &&
    confirmPasswordInputIsValid
  ) {
    formIsValid = true;
  }

  const currentPasswordInputClasses = currentPasswordInputIsInvalid
    ? `${cf.field} ${cf.invalid}`
    : cf.field;

  const passwordInputClasses = passwordInputIsInvalid
    ? `${cf.field} ${cf.invalid}`
    : cf.field;

  const confirmPasswordInputClasses = confirmPasswordInputIsInvalid
    ? `${cf.field} ${cf.invalid}`
    : cf.field;

  const switchEyeIcon = () => {
    setShowPassword((initialstate) => !initialstate);
  };

  const switchType = (val) => {
    setPasswordType(val);
  };
  const switchEyeIcon2 = () => {
    setShowPassword2((initialstate) => !initialstate);
  };

  const switchType2 = (val) => {
    setPasswordType2(val);
  };
  const switchEyeIcon3 = () => {
    setShowPassword3((initialstate) => !initialstate);
  };

  const switchType3 = (val) => {
    setPasswordType3(val);
  };

  const passwordActionSee = () => {
    switchEyeIcon();
    switchType("text");
  };
  const passwordActioBlind = () => {
    switchEyeIcon();
    switchType("password");
  };

  const passwordActionSee2 = () => {
    switchEyeIcon2();
    switchType2("text");
  };
  const passwordActioBlind2 = () => {
    switchEyeIcon2();
    switchType2("password");
  };

  const passwordActionSee3 = () => {
    switchEyeIcon3();
    switchType3("text");
  };
  const passwordActioBlind3 = () => {
    switchEyeIcon3();
    switchType3("password");
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    setShowSpinner(true);

    const data = {
      passwordCurrent: currentPasswordInput,
      password: passwordInput,
      passwordConfirm: confirmPasswordInput,
    };

    const res = await updatePassword(jwt, data);

    if (res.status === "success") {
      dispatch(
        alertActions.setState({ message: res.message, status: res.status })
      );
    } else {
      dispatch(
        alertActions.setState({ message: res.message, status: "error" })
      );
    }

    setShowSpinner(false);
    currentPasswordInputReset();
    passwordInputReset();
    confirmPasswordInputReset();
    setTimeout(() => {
      dispatch(alertActions.resetState());
    }, 3000);
  };

  return (
    <form className={cf.form} onSubmit={submitHandler}>
      {showSpinner && <Spinner />}
      <div className={cf.formTitleRow}>
        <HiOutlineLockClosed className={cf.formTitleIcon} aria-hidden />
        <h2 className={cf.formTitle}>Change your password</h2>
      </div>
      <p className={cf.formSubtitle}>
        For security, enter your current password, then your new password twice.
      </p>
      <div className={currentPasswordInputClasses}>
        <label htmlFor="dash-current-pw">Current password</label>
        <div className={cf.inputGroup}>
          <BsKeyFill className={cf.icon} />
          <input
            id="dash-current-pw"
            type={passwordType}
            autoComplete="current-password"
            value={currentPasswordInput}
            onChange={currentPasswordInputChangedHandler}
            onBlur={currentPasswordInputBlurHandler}
          />
          {!showPassword && (
            <BsEyeFill
              className={`${cf.icon} ${cf.iconButton}`}
              onClick={passwordActionSee}
              role="button"
              tabIndex={0}
              aria-label="Show password"
            />
          )}
          {showPassword && (
            <BsEyeSlashFill
              className={`${cf.icon} ${cf.iconButton}`}
              onClick={passwordActioBlind}
              role="button"
              tabIndex={0}
              aria-label="Hide password"
            />
          )}
        </div>
        {currentPasswordInputIsInvalid && (
          <span className={cf.fieldError}>This field cannot be empty.</span>
        )}
      </div>
      <div className={passwordInputClasses}>
        <label htmlFor="dash-new-pw">New password</label>
        <div className={cf.inputGroup}>
          <BsKeyFill className={cf.icon} />
          <input
            id="dash-new-pw"
            type={passwordType2}
            autoComplete="new-password"
            value={passwordInput}
            onChange={passwordInputChangedHandler}
            onBlur={passwordInputBlurHandler}
          />
          {!showPassword2 && (
            <BsEyeFill
              className={`${cf.icon} ${cf.iconButton}`}
              onClick={passwordActionSee2}
              role="button"
              tabIndex={0}
              aria-label="Show password"
            />
          )}
          {showPassword2 && (
            <BsEyeSlashFill
              className={`${cf.icon} ${cf.iconButton}`}
              onClick={passwordActioBlind2}
              role="button"
              tabIndex={0}
              aria-label="Hide password"
            />
          )}
        </div>
        {passwordInputIsInvalid && (
          <span className={cf.fieldError}>This field cannot be empty.</span>
        )}
      </div>
      <div className={confirmPasswordInputClasses}>
        <label htmlFor="dash-confirm-pw">Confirm new password</label>
        <div className={cf.inputGroup}>
          <BsKeyFill className={cf.icon} />
          <input
            id="dash-confirm-pw"
            type={passwordType3}
            autoComplete="new-password"
            value={confirmPasswordInput}
            onChange={confirmPasswordInputChangedHandler}
            onBlur={confirmPasswordInputBlurHandler}
          />
          {!showPassword3 && (
            <BsEyeFill
              className={`${cf.icon} ${cf.iconButton}`}
              onClick={passwordActionSee3}
              role="button"
              tabIndex={0}
              aria-label="Show password"
            />
          )}
          {showPassword3 && (
            <BsEyeSlashFill
              className={`${cf.icon} ${cf.iconButton}`}
              onClick={passwordActioBlind3}
              role="button"
              tabIndex={0}
              aria-label="Hide password"
            />
          )}
        </div>
        {confirmPasswordInputIsInvalid && (
          <span className={cf.fieldError}>This field cannot be empty.</span>
        )}
      </div>
      <div className={cf.actions}>
        <button type="submit" disabled={!formIsValid}>
          <HiCheck className={cf.btnIcon} aria-hidden />
          Change password
        </button>
      </div>
    </form>
  );
};

export default Password;
